export default {
    info: 'info',
    success: 'success',
    warning: 'warning',
    error: 'error'
};
